"use client";

import SuspenseFallback from "@/components/framework/SuspenseFallback";
import getTrailerEmbed from "@/lib/client/getTrailerEmbed";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import styles from "./TrailerOverlay.module.css";
import Close from "@/components/images/Close";

//#region [Props]
type TrailerOverlayProps = {
    videoId: string;
    doClose: () => void;
};
//#endregion

//#region [Component]
export default function TrailerOverlay({ videoId, doClose }: TrailerOverlayProps) {

    const { data, isFetching, isError } = useQuery({
        queryKey: ["getTrailerEmbed", videoId],
        queryFn: getTrailerEmbed
    });

    useEffect(() => {
        document.body.classList.add(styles.NoScroll);
        return () => {
            document.body.classList.remove(styles.NoScroll);
        }
    }, []);


    return <div className={styles.Overlay} onClick={doClose}>
        {isError && <div>Traileren kan ikke vises.</div>}
        {isFetching && <SuspenseFallback theme="light" />}
        {data && !isFetching && <div className={styles.Container}><button className={styles.Close}><Close /></button><div dangerouslySetInnerHTML={{ __html: data }}></div></div>}
    </div>;
}
//#endregion
